import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export default function initSwiper() {
  document.querySelectorAll('.swiper-visual-product').forEach(($mainSwiper) => {
    const shouldInitialize = !$mainSwiper.classList.contains('swiper-initialized');

    if (!shouldInitialize) {
      return;
    }

    // eslint-disable-next-line no-new
    new Swiper(($mainSwiper as HTMLElement), {
      slidesPerView: 'auto',
      grabCursor: true,
      spaceBetween: 16,
      breakpoints: {
        1024: {
          spaceBetween: 0,
        },
      },
    });
  });

  document.querySelectorAll('.swiper-product-var').forEach(($mainSwiper) => {
    const shouldInitialize = !$mainSwiper.classList.contains('swiper-initialized');

    if (!shouldInitialize) {
      return;
    }

    // eslint-disable-next-line no-new
    new Swiper(($mainSwiper as HTMLElement), {
      slidesPerView: 'auto',
      grabCursor: true,
      spaceBetween: 12,
      breakpoints: {
        1024: {
          spaceBetween: 0,
        },
      },
    });
  });

  document.querySelectorAll('.swiper-usp').forEach(($mainSwiper) => {
    const shouldInitialize = !$mainSwiper.classList.contains('swiper-initialized');

    if (!shouldInitialize) {
      return;
    }

    // eslint-disable-next-line no-new
    new Swiper(($mainSwiper as HTMLElement), {
      modules: [Autoplay],
      slidesPerView: 1,
      grabCursor: true,
      spaceBetween: 0,
      autoHeight: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          autoHeight: false,
          slidesPerView: 'auto',
        },
      },
    });
  });
}
